import axios from 'axios';
import {getBaseUrl} from './UtilRepository';

export const getContributionData = async (accessToken, isOkta) => {
    const url = await getBaseUrl(isOkta);
    const response = await axios.get(
        `${url}/contributions`,
        {headers: {Authorization: `Bearer ${accessToken}`}}
    );
    return response.data;
};